import React from 'react';
import { Link } from 'react-router-dom';
import lakeEmblem from '../assets/brand/sanctuary-emblem.png';

export default function SidebarBrand({ name, compact }: { name?: string; compact: boolean }) {
  return <Link to="/" aria-label={name ? `${name} — Open the field map` : 'Open the field map'} className={`sidebar-brand${compact ? ' sidebar-brand--compact' : ''}`}>
    <span className="sidebar-emblem"><img src={lakeEmblem} alt="" aria-hidden="true" width={256} height={256} draggable={false} /></span>
    {!compact && name && <span className="sidebar-property-name">{name}</span>}
  </Link>;
}
